import React, { useEffect, useState } from 'react';
import CVGauge from './CVGauge';

const SOURCES = [
  '2Seam',
  '4SeamLower',
  '4SeamA',
  '4SeamUpper',
  'MixedOversize',
  'Rewash Coal',
];

function ProductCVGauges({ range = '7d', start, end }) {
  const [values, setValues] = useState({});

  const ranges = {
    '2Seam': 55,
    '4SeamA': 55,
    '4SeamLower': 45,
    '4SeamUpper': 46,
    'MixedOversize': 51,
    'Rewash Coal': 41,
  };

  useEffect(() => {
    const srcParam = SOURCES.map(encodeURIComponent).join(',');
    const params = start && end
      ? `start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
      : `time_range=${range}`;
    fetch(`/api/dms-product-cv-sum.php?${params}&sources=${srcParam}`)
      .then(res => res.json())
      .then(res => setValues(res || {}))
      .catch(() => setValues({}));
  }, [range, start, end]);

  const targets = {
    '2Seam': 27.15,
    '4SeamLower': 22.34,
    '4SeamA': 27.15,
    '4SeamUpper': 23.07,
    'MixedOversize': 25.1,
    'Rewash Coal': 20.46,
  };

  return (
    <div className="mt-4 flex-1 space-y-2">
      <div className="grid grid-cols-7 gap-4 items-end">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Current
        </div>
        {SOURCES.map(src => {
          const val = values[src];
          const thresholds = [0, ranges[src]];
          return (
            <CVGauge
              key={src}
              source={src}
              value={val ?? 0}
              thresholds={thresholds}
              showSideLabels={false}
              gradient
            />
          );
        })}
      </div>
      <div className="grid grid-cols-7 gap-4 items-center">
        <div className="flex items-center justify-center text-[12px] font-semibold">
          Target
        </div>
        {SOURCES.map(src => (
          <div key={src} className="flex items-center justify-center">
            <span className="px-1.5 py-0.5 rounded-full text-white text-[12px] font-semibold" style={{ backgroundColor: '#21C55E' }}>
              {targets[src]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductCVGauges;
